import { render, staticRenderFns } from "./newform-nasabah.vue?vue&type=template&id=32192375&scoped=true&"
import script from "./newform-nasabah.vue?vue&type=script&lang=js&"
export * from "./newform-nasabah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32192375",
  null
  
)

export default component.exports